import * as React from 'react';
import titleTemplate from 'lib/title-template';
import Head from 'next/head';
import Page from 'components/common/page';
import Section from 'components/section';
import UniversitiesMarquee from 'components/universities-marquee';
import FaqList from 'components/faq-list';
import Footer from 'components/footer';
import sharedCSS from './styles/shared.module.css';
import forOrganizationsCSS from './styles/for-organizations.module.css';
import faqCSS from './styles/faq.module.css';

const Integration = (): JSX.Element => {
  return (
    <Page pageName="About for Organizations">
      <Head>
        <title>{titleTemplate('About')}</title>
      </Head>
      <div className={sharedCSS.body}>
        <div className={sharedCSS.one}>
          <div className={sharedCSS.row}>
            <div
              className={`${forOrganizationsCSS.column} ${sharedCSS.column}`}
            >
              <div className={forOrganizationsCSS.text}>
                <div className={sharedCSS.contentTitle}>
                  Take Bibcitation to-go with our new website integration
                </div>
                <br />
                <div className={sharedCSS.mobileImage}>
                  <img
                    src={require('images/integrate-citation-generator.png')}
                    alt="Cite sources on your website"
                    width={360}
                  />
                </div>
                <div
                  className={`${forOrganizationsCSS.text1} ${sharedCSS.text1}`}
                >
                  <p>
                    Add Bibcitation to your organization website and take
                    advantage of our stunning interface and latest reference
                    software. For free.
                  </p>
                  <p>
                    Our integration lets your users create citations in one
                    click — with a bite-sized button that will seamlessly fit
                    into your website page.
                  </p>
                </div>
              </div>
            </div>

            <div className={sharedCSS.breaker}></div>

            <div className={sharedCSS.image}>
              <img
                src={require('images/integrate-citation-generator.png')}
                alt="Cite sources on your website"
                width={650}
              />
            </div>
          </div>
          <UniversitiesMarquee />
        </div>

        <div className={forOrganizationsCSS.instructionSection}>
          <div className={forOrganizationsCSS.instructionTitle}>
            Book a free demo session
          </div>
          <br />
          <div className={sharedCSS.instructionText}>
            <p>
              Schedule a Bibcitation demo to see why thousands of university
              students are already creating references with us. We can&apos;t
              wait to show you around!
            </p>

            <div className={sharedCSS.buttonFeature}>
              <div className={sharedCSS.buttonInside}>
                <a href="https://calendly.com/milena-bibcitation/bibcitation-demo">
                  {' '}
                  <div className={sharedCSS.demoButton}>Book a Demo</div>
                </a>
              </div>

              <div className={sharedCSS.buttonInside}></div>
              <div className={sharedCSS.buttonInside}>
                <a
                  className={sharedCSS.noStyleLink}
                  href="https://www.bibcitation.com/contact"
                >
                  {' '}
                  <div className={sharedCSS.contactButton}>Contact Us</div>
                </a>
              </div>
            </div>
          </div>{' '}
        </div>

        <div className={sharedCSS.sectionOne}>
          <div className={sharedCSS.inside}>
            <div className={sharedCSS.image}>
              <img
                src={require('images/choose-source.png')}
                alt="Cite sources on your website"
                width={500}
              />
            </div>{' '}
          </div>

          <div className={sharedCSS.inside}>
            <div className={sharedCSS.sectionTitle}>
              Pick a source you want to cite on your website
            </div>
            <div className={sharedCSS.mobileImage}>
              <img
                src={require('images/choose-source.png')}
                alt="Cite sources on your website"
                width={360}
              />
            </div>
            <br />
            <div className={sharedCSS.sectionText}>
              <p>
                There are 130 million books in the world. And yes, Bibcitation
                can cite all of them, in over 9 thousand formats! Choose your
                book and set up the integration to create your citation.
              </p>
            </div>{' '}
          </div>
        </div>

        <div className={sharedCSS.sectionTwoLast}>
          <div className={forOrganizationsCSS.insideTwoLeft}>
            <div className={sharedCSS.sectionTitle}>
              Add our magical citation button to your site code
            </div>
            <br />
            <div className={sharedCSS.sectionText}>
              <p>
                We know you&apos;ve spent thousands of dollars on branding, so
                our citation feature will seamlessly integrate into your user
                interface. Use custom code to &#60;style&#62; your citation
                button — no questions asked.
              </p>
            </div>{' '}
          </div>

          <div className={forOrganizationsCSS.insideTwoRight}>
            {' '}
            <div className={sharedCSS.sectionImage}>
              <img
                src={require('images/incorporate-generator-web-page.png')}
                alt="Cite sources on your website"
                width={550}
              />
            </div>{' '}
          </div>
        </div>

        <div className={sharedCSS.sectionThree}>
          <div className={sharedCSS.insideThree}>
            <div className={sharedCSS.image}>
              <img
                src={require('images/create-citations-apa-mla.png')}
                alt="Cite sources on your website"
                width={530}
              />
            </div>{' '}
          </div>
          <div className={sharedCSS.insideThree}>
            <div className={sharedCSS.sectionTitle}>
              Sit back, relax and let our citation tool do the work
            </div>
            <br />
            <div className={sharedCSS.sectionText}>
              <p>
                With one click of a button, users can now create citations for
                your sources, add references to their project or bibliography,
                and export sources as a part of their citation list.{' '}
              </p>
              <p>Oh, and did we mention that it&apos;s free?</p>
            </div>{' '}
          </div>{' '}
        </div>

        <div className={sharedCSS.instructionFinal}>
          <div className={forOrganizationsCSS.instructionTitle2}>
            Add the button to your page
          </div>
          <div className={sharedCSS.sectionTwo}>
            <div className={sharedCSS.insideTwoRightInstruction}>
              {' '}
              <div className={sharedCSS.sectionImage}>
                <img
                  src={require('images/install-button.png')}
                  alt="Cite sources on your website"
                  width={600}
                />
              </div>{' '}
            </div>
            <div className={forOrganizationsCSS.insideTwoLeftInstruction}>
              <br />
              <div className={forOrganizationsCSS.sectionTextInstruction}>
                <p>
                  Fetch ISBN codes for all the sources you want to cite. We
                  decided to use <i>Capital</i> by Thomas Piketty with the
                  following ISBN number:
                </p>

                <div className={sharedCSS.codeFirst}>
                  &#65121; ISBN: 978067497985
                </div>

                <p>
                  Copy the link below and replace &quot;xxxxxx&quot; with your
                  custom ISBN:
                </p>

                <div className={sharedCSS.codeSecond}>
                  &#65121; https://www.bibcitation.com/?type=book&query=xxxxxx
                </div>

                <p>
                  Now code your citation button. Below we used the
                  &#60;button&#62; tag, but you are free to choose any
                  programming language you see fit.
                </p>
                <div className={sharedCSS.codeThird}>
                  &#60;button
                  onclick=&quot;window.location.href=&apos;link&apos;;&quot;&#62;
                  text &#60;/button&#62;
                </div>

                <p>
                  All done. Time to add your link to the button code on your
                  website!
                </p>
                <div className={sharedCSS.codeFourth}>
                  &#65121;
                  href=&apos;https://www.bibcitation.com/?type=book&query=9780674979857&apos;
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={sharedCSS.oneM}>
          <div className={forOrganizationsCSS.rowM}>
            <div className={sharedCSS.columnM}>
              <div className={sharedCSS.textM}>
                <div className={sharedCSS.contentTitleM}>
                  First, choose a book you want to cite on your page
                </div>
                <br />
                <div className={sharedCSS.mobileImageM}>
                  <img
                    src={require('images/choose-source.png')}
                    alt="Cite sources on your website"
                    width={360}
                  />
                </div>
                <div className={sharedCSS.text1M}>
                  <p>
                    There are 130 million books in the world. And yes,
                    Bibcitation can cite all of them, in over 9 thousand
                    formats! Choose your book and set up the integration to
                    create your citation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={sharedCSS.oneM}>
          <div className={forOrganizationsCSS.rowM}>
            <div className={sharedCSS.columnM}>
              <div className={sharedCSS.textM}>
                <div className={sharedCSS.contentTitleM}>
                  Add our magical citation button to your site code
                </div>
                <br />
                <div className={sharedCSS.mobileImageM}>
                  <img
                    src={require('images/incorporate-generator-web-page.png')}
                    alt="Cite sources on your website"
                    width={360}
                  />
                </div>
                <div className={sharedCSS.text1M}>
                  <p>
                    We know you&apos;ve spent thousands of dollars on branding,
                    so our feature will seamlessly integrate into your user
                    interface. Use custom code to &#60;style&#62; your citation
                    button — no questions asked.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={sharedCSS.oneM}>
          <div className={forOrganizationsCSS.rowM}>
            <div className={sharedCSS.columnM}>
              <div className={sharedCSS.textM}>
                <div className={sharedCSS.contentTitleM}>
                  Sit back, relax and let our citation tool do the work
                </div>
                <br />
                <div className={sharedCSS.mobileImageM}>
                  <img
                    src={require('images/create-citations-apa-mla.png')}
                    alt="Cite sources on your website"
                    width={360}
                  />
                </div>
                <div className={sharedCSS.text1M}>
                  <p>
                    With one click of a button, users can now create citations
                    for your sources, add references to their project or
                    bibliography, and export sources as a part of their citation
                    list.{' '}
                  </p>
                  <p>Oh, and did we mention that it&apos;s free?</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={sharedCSS.oneLast}>
          <div className={forOrganizationsCSS.rowM}>
            <div className={sharedCSS.columnLast}>
              <div className={sharedCSS.textM}>
                <div className={sharedCSS.contentTitleM}>
                  Add the button to your web page
                </div>
                <br />
                <div className={sharedCSS.mobileImageM}>
                  <img
                    src={require('images/install-button.png')}
                    alt="Cite sources on your website"
                    width={360}
                  />
                </div>
                <div className={sharedCSS.text1L}>
                  <p>
                    Fetch ISBN codes for all the sources you want to cite. We
                    decided to use <i>Capital</i> by Thomas Piketty with the
                    following ISBN number:
                  </p>

                  <div className={sharedCSS.codeFirst}>ISBN: 978067497985</div>

                  <p>
                    Copy the link below and replace &quot;xxxxxx&quot; with your
                    custom ISBN:
                  </p>

                  <div className={sharedCSS.codeSecond}>
                    https://www.bibcitation.com/?type=book&query=xxxxxx
                  </div>

                  <p>
                    Now code your citation button. Below we used the
                    &#60;button&#62; tag, but you are free to choose any
                    programming language you see fit.
                  </p>
                  <div className={sharedCSS.codeThird}>
                    &#60;button
                    onclick=&quot;window.location.href=&apos;link&apos;;&quot;&#62;
                  </div>

                  <p>
                    All done. Time to add your link to the button code on your
                    website!
                  </p>
                  <div className={sharedCSS.codeFourth}>
                    href=&apos;https://www.bibcitation.com/?type=book&query=9780674979857&apos;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FAQ />
        <Footer />
      </div>
    </Page>
  );
};

const FAQ = (): JSX.Element => {
  return (
    <Section>
      <div className={`${faqCSS.content} ${faqCSS.faq}`}>
        <h2
          className={`${faqCSS.faqTitle} ${faqCSS.heading} ${faqCSS.headingLarge}`}
        >
          Frequently Asked Questions
        </h2>
        <FaqList />
        <p className={`${faqCSS.paragraph} ${faqCSS.paragraphMedium}`}></p>
      </div>
    </Section>
  );
};

export default Integration;
